import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, toRefs } from '@nuxtjs/composition-api';

interface Props {
    variant?: 'with-icon' | 'without-icon',
    buttonSize?: 's' | 'm' | 'l' | 'xl',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguagesSwitch',
  props: {
    variant: { default: 'without-icon' },
    buttonSize: { default: 's' }
  },
  emits: ['locale-changed'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { variant: 'with-icon' | 'without-icon', buttonSize: 's' | 'm' | 'l' | 'xl' };

const lngKeys = {
    en: 'English',
    es: "Español",
    jp: '日本語',
    ko: "한국어",
    pt: "Português",
    ru: "Русский",
    th: "ไทย",
    vn: "Tiếng Việt",
    zh: "中文",
};




const {
    buttonSize,
} = toRefs(props);

const context = useContext();
const { availableLocales } = context.i18n;

const currentLocale = computed(() => context.i18n.locale);

const switchLocale = (locale: string) => {
    localStorage.setItem('locale', locale);
    context.i18n.setLocale(locale);
    $emit('locale-changed', locale);
};


return { __sfc: true,lngKeys, $emit, props, buttonSize, context, availableLocales, currentLocale, switchLocale }
}

})